<template>
    <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
    >
    <v-card>
        <v-card-title class="justify-space-between">
            <v-spacer></v-spacer>
            <v-btn icon  @click="sheet = false"> <Close /></v-btn>
        </v-card-title>
        <v-card-text  class="sheet-body" >
            <div class="d-flex gap-6 pa-3 pt-1">
                <Flicking ref="flickYear" :options="{ horizontal: false }" class="date-flicking" @changed="selectYear">
                    <div v-for="(item,index) in year" :key="index" class="date-panel">{{item}}</div>
                    <div slot="viewport" class="date-panel-border"></div>
                    <div slot="viewport" class="shadow-top"></div>
                    <div slot="viewport" class="shadow-bottom"></div>
                </Flicking>
                <Flicking ref="flickMonth" :options="{ horizontal: false }" class="date-flicking" @changed="selectMonth">
                    <div v-for="(item,index) in month" :key="index" class="date-panel">{{item}}</div>
                    <div slot="viewport" class="date-panel-border"></div>
                    <div slot="viewport" class="shadow-top"></div>
                    <div slot="viewport" class="shadow-bottom"></div>
                </Flicking>
                <Flicking ref="flickDay" :options="{ horizontal: false }" class="date-flicking" @changed="selectDay">
                    <div v-for="(item,index) in day" :key="index" class="date-panel">{{item}}</div>
                    <div slot="viewport" class="date-panel-border"></div>
                    <div slot="viewport" class="shadow-top"></div>
                    <div slot="viewport" class="shadow-bottom"></div>
                </Flicking>
            </div>
        </v-card-text>
        <v-card-actions class="sheet-footer">
            <BlackBtn x-large str="확인" @click="confirm"></BlackBtn>
        </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close';
import BlackBtn from "@/components/btns/BlackBtn";
export default {
  data: () => ({
    sheet: false,
    year: [],
    month: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    day: [],
    selectyear: new Date().getFullYear(),
    selectmonth: (new Date().getMonth() + 1).toString().padStart(2, '0'),
    selectday: new Date().getDate().toString().padStart(2, '0')
  }),
  created() {
    let date = new Date();
    let year = date.getFullYear();
    for (let i = 1900; i <= year; i++) {
      this.year.push(i);
    }
    this.updateDays();
  },
  computed: {},
  components: {
    BlackBtn,
    Close
  },
  watch:{
  },
  methods: {
    setFlicking(year, month, day) {
      this.$nextTick(() => {
        this.selectyear = year;
        this.selectmonth = month;
        this.selectday = day;
        this.sheet = true;
      });
    },
    selectYear(e) {
      this.$nextTick(() => {
        this.selectyear = this.year[e.index];
        this.updateDays();
      });
    },
    selectMonth(e) {
      this.$nextTick(() => {
        this.selectmonth = this.month[e.index];
        this.updateDays();
      });
    },
    selectDay(e) {
      this.$nextTick(() => {
        this.selectday = this.day[e.index];
      });
    },
    confirm() {
      this.$nextTick(() => {
        this.sheet = false;
        this.$emit('selectValue', this.selectyear, this.selectmonth, this.selectday);
      });
    },
    updateDays() {
      const daysInMonth = new Date(this.selectyear, parseInt(this.selectmonth), 0).getDate();
      this.day = Array.from({ length: daysInMonth }, (v, k) => (k + 1).toString().padStart(2, '0'));
      if (parseInt(this.selectday) > daysInMonth) {
        this.selectday = daysInMonth.toString().padStart(2, '0');
        this.$nextTick(() => {
          const dayIndex = this.day.indexOf(this.selectday);
          this.$refs.flickDay.moveTo(dayIndex);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lightBlue--text {
	color:blue;
}
.flicking-viewport {
    margin-left: auto;
    margin-right: auto;
    transition: height .5s;
    width: 100%;
    overflow: hidden;
    position: relative;
}
.date-flicking {
    box-sizing: content-box;
    height: 184px;
    perspective: 184px;
    overflow: hidden;
}
.date-flicking, .date-flicking>.flicking-camera {
    transform-style: preserve-3d;
}
.date-panel {
    align-items: center;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    height: 60px;
    line-height: 62px;
    font-size:20px;
    font-weight: bold;
    text-align: center;
}
.date-panel-border {
    border-bottom: 2px solid #ddd;
    border-top: 2px solid #ddd;
    height: 60px;
    left: 0;
    position: absolute;
    top: 60px;
    width: 100%;
}
.shadow-bottom, .shadow-top {
    background-color: rgba(255,255,255,.8);
    height: 60px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index:2;
}
.shadow-bottom {
    top: 124px;
}
</style>
